var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tenant-submission-documents" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.files.length > 0,
            expression: "files.length > 0",
          },
        ],
        staticClass: "column-header",
      },
      [_vm._v("\n    " + _vm._s(_vm.$t("attachments")) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "contents" },
      [
        _vm._l(_vm.files, function (file, index) {
          return _c("div", { key: index, staticClass: "file-panel" }, [
            _c("div", { staticClass: "panel" }, [
              _c(
                "a",
                {
                  staticClass: "download-link tender-font",
                  on: {
                    click: function ($event) {
                      return _vm.downloadFile(file.id)
                    },
                  },
                },
                [_vm._v("\n          " + _vm._s(file.filename) + "\n        ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.allowChangeName[file.id],
                      expression: "allowChangeName[file.id]",
                    },
                  ],
                },
                [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: file.description,
                        expression: "file.description",
                      },
                      { name: "autosize", rawName: "v-autosize" },
                      {
                        name: "checkVisibility",
                        rawName: "v-checkVisibility",
                        value: { refresh: true },
                        expression: "{refresh: true}",
                      },
                    ],
                    staticClass: "doc-desc__textarea tender-font",
                    attrs: { autofocus: "" },
                    domProps: { value: file.description },
                    on: {
                      focusout: function ($event) {
                        return _vm.updateDescription(file)
                      },
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(file, "description", $event.target.value)
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.allowChangeName[file.id],
                      expression: "!allowChangeName[file.id]",
                    },
                  ],
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "desc-text",
                      on: {
                        dblclick: function ($event) {
                          return _vm.dblClickEdit(file.id)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            file.description ||
                              (_vm.canEdit
                                ? _vm.$t("project.docs.fillDescHint")
                                : "")
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.canEdit
                    ? _c("i", {
                        staticClass: "fa fa-pencil icon",
                        on: {
                          click: function ($event) {
                            return _vm.Vue.set(
                              _vm.allowChangeName,
                              file.id,
                              true
                            )
                          },
                        },
                      })
                    : _vm._e(),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "panel" }, [
              _vm.canEdit
                ? _c("i", {
                    staticClass: "fa fa-times fa-lg",
                    on: {
                      click: function ($event) {
                        return _vm.deleteFile(file)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isTenant
                ? _c("p", { staticClass: "updator-text" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("tenantProjects.uploadedBy", [
                            _vm.findCreatorName(file),
                          ])
                        ) +
                        "\n          "
                    ),
                    _c("span", { staticClass: "update-date" }, [
                      _vm._v(
                        _vm._s(_vm.dateUtil.format(file.createdAt, "DD MMM YY"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "update-date" }, [
                      _vm._v(
                        _vm._s(_vm.dateUtil.format(file.createdAt, "HH:mm"))
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ])
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.canDownloadAll && _vm.files.length > 0,
                expression: "canDownloadAll && files.length > 0",
              },
            ],
            staticClass: "projects-download-all clearfix",
          },
          [
            _c(
              "button",
              {
                staticClass:
                  "btn btn--darkblue tender-sticky-button float-left",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.downloadAll(_vm.sourceId)
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("action.download")) +
                    " " +
                    _vm._s(_vm.$t("all"))
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "float-right clearfix" },
              [_vm._t("buttons")],
              2
            ),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }